"use client";

import clsx from "clsx";
import Link from "next/link";
import { ReactNode, memo } from "react";

import FileFrame from "components/FileFrame";
import { cn } from "utils/cn";

type TValueData = {
  value: string;
  className?: string;
};

const FormField = memo(
  ({
    value,
    isFile = false,
    name,
    nameNode,
    href,
    noBottomBorder = false,
    nameWrapperClassName,
    headerClassName,
    valueClassName,
    fileClassName,
    emptyClassName,
    wrapperClassName,
    isSolidBorder,
  }: {
    value: string | TValueData[];
    isFile?: boolean;
    name?: string;
    nameNode?: ReactNode;
    href?: string;
    noBottomBorder?: boolean;
    nameWrapperClassName?: string;
    headerClassName?: string;
    valueClassName?: string;
    fileClassName?: string;
    emptyClassName?: string;
    wrapperClassName?: string;
    isSolidBorder?: boolean;
  }) => {
    return (
      <div
        className={clsx(
          "flex w-full items-center py-2 text-[13.71px]",
          noBottomBorder ? null : "border-b",
          {
            "border-text-gray": isSolidBorder,
          },
          wrapperClassName
        )}
      >
        {(name || nameNode) && (
          <div className={nameWrapperClassName}>
            <p className={cn("min-w-[200px]", headerClassName)}>{name || nameNode}</p>
            {nameNode != null && <p className="min-w-[200px]">{nameNode}</p>}
          </div>
        )}
        {isFile && typeof value === "string" ? (
          <FileFrame src={value === "" ? undefined : value} className={fileClassName} emptyClassName={emptyClassName} />
        ) : href ? (
          <Link className="text-primary hover:text-linkDark" href={href} target="_blank">
            {value as string}
          </Link>
        ) : Array.isArray(value) ? (
          <div className="flex">
            {value.map((item, index) => (
              <p key={index} className={item.className}>
                {item.value}
              </p>
            ))}
          </div>
        ) : (
          <span className={valueClassName}>{value}</span>
        )}
      </div>
    );
  }
);

FormField.displayName = "FormField";

export default FormField;
